import React from "react";

class PaymentCancel extends React.Component {
  render() {
    return (
      <div style={{ padding: 80, textAlign: "center" }}>
        <h1>✅ Payment Cancel</h1>
        <p>Your booking is cancel.</p>
      </div>
    );
  }
}

export default PaymentCancel;
